import React, { useState } from "react";

import MdlSidebarOverlay from "../Sidebar/MdlSidebarOverlay";
import MdlSidebarSheetUpload from "../Sidebar/MdlSidebarSheetUpload";

function NoSheets() {
  const [uploadModal, setUploadModal] = useState(false);

  return (
    <div className="notfound">
      <div className="notfound-404">
        <h1>Oops!</h1>
        <h2>Upload Sheets to begin</h2>
      </div>
      <p onClick={() => setUploadModal(true)} className="cursor">
        Upload Sheet
      </p>
      <MdlSidebarOverlay
        title="Upload"
        onClose={() => setUploadModal(false)}
        show={uploadModal}
      >
        <MdlSidebarSheetUpload onClose={() => setUploadModal(false)} />
      </MdlSidebarOverlay>
    </div>
  );
}

export default NoSheets;
